import { IconButton } from '@mui/material';
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

import ArgonTypography from 'component/Argon/ArgonTypography';

export const DownloadIcon = ({ title, color }) => (
  <IconButton>
    <ArgonTypography variant="body1" color={color || 'secondary'} sx={{ lineHeight: 0 }}>
      <Tooltip title={title || 'รอดำเนินการ'} placement="top">
        <Icon>download</Icon>
      </Tooltip>
    </ArgonTypography>
  </IconButton>
);

export const RefreshIcon = ({ onClick }) => (
  <IconButton>
    <ArgonTypography onClick={onClick} variant="body1" color="secondary" sx={{ lineHeight: 0 }}>
      <Tooltip title="ลองอีกครั้ง" placement="top">
        <Icon>refresh</Icon>
      </Tooltip>
    </ArgonTypography>
  </IconButton>
);
